import Cookies from "js-cookie"
import { RepOffice } from "../model/RepOffice"
import { apiRoutes } from "../routes"
import { useFetch } from "../utils/reactQuery"

export const useGetRepOffices = () => {
    const context = useFetch<RepOffice[]>(apiRoutes.getRepOffices, {}, {retry: false, enabled: !!Cookies.get('token')})
    return context
}